import { render, staticRenderFns } from "./ProjectStudentViewT.vue?vue&type=template&id=34d6eba0&scoped=true&"
import script from "./ProjectStudentViewT.vue?vue&type=script&lang=ts&"
export * from "./ProjectStudentViewT.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectStudentViewT.vue?vue&type=style&index=0&id=34d6eba0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34d6eba0",
  null
  
)

export default component.exports